// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + "vendor-xlsx" + "." + "2bceed4c9cc6af704bdc" + ".js";
};